import { useObservableState } from 'observable-hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import List from '../../../components/common/list';
import Title from '../../../components/common/title';
import EmailTemplate from '../../../interfaces/email-template';
import { INTERNAL_EMAIL_TEMPLATE_EDIT } from '../../../router/routes';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import css from './index.module.css';

export default function EmailTemplates() {
  const { t } = useTranslation();
  const { emailTemplateService } = useService();
  const [data, setData] = useState([]);

  const [emailTemplates] = useObservableState<EmailTemplate[]>(() =>
    emailTemplateService.index()
  );

  useEffect(() => {
    const templates = emailTemplates?.map((template) => {
      return {
        id: template.id,
        value: template.name,
        transferUrl: route(INTERNAL_EMAIL_TEMPLATE_EDIT, {
          id: template.id,
        }),
      };
    });
    setData(templates || []);
  }, [emailTemplates, setData]);

  return (
    <div className={css['index']}>
      <Title title={t('Email templates')} />
      <div className={css['body']}>
        <List data={data} />
      </div>
    </div>
  );
}
